import React from 'react';
import { usePageMeta } from '../Hooks';
import './Pages.css';

const PrivacyPolicy: React.FC = () => {
  usePageMeta(
    'Privacy Policy | UK Pension vs Index Fund Calculator',
    'Privacy policy for the UK Pension vs Index Fund Calculator. Learn how we handle your data.'
  );

  return (
    <div className="page-container">
      <h1>Privacy Policy</h1>
      <div className="page-content">
        <p><strong>Last updated:</strong> 3rd March 2026</p>

        <h2>1. Information We Collect</h2>
        <p>
          We collect information you provide directly to us when using our pension vs index fund calculator, 
          including any input data for calculations.
        </p>

        <h2>2. How We Use Your Information</h2>
        <p>
          We use the information we collect to:
        </p>
        <ul>
          <li>Provide, maintain, and improve our calculator service</li>
          <li>Process and respond to your inquiries</li>
          <li>Monitor and analyze trends and usage</li>
        </ul>

        <h2>3. Information Sharing</h2>
        <p>
          We do not sell, trade, or otherwise transfer your personal information to third parties 
          without your consent, except as described in this policy.
        </p>

        <h2>4. Cookies and Tracking</h2>
        <p>
          We use cookies to enhance your experience on our website. You can control cookie 
          preferences through your browser settings.
        </p>

        {/* <h2>5. Google AdSense</h2>
        <p>
          This website uses Google AdSense to display advertisements. Google may use cookies 
          to serve ads based on your prior visits to this website or other websites. You may 
          opt out of personalized advertising by visiting 
          <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">
            Google's Ads Settings
          </a>.
        </p> */}

        <h2>5. Data Security</h2>
        <p>
          We implement appropriate security measures to protect your personal information 
          against unauthorized access, alteration, disclosure, or destruction.
        </p>

        <h2>6. Changes to Privacy Policy</h2>
        <p>
          We may update this privacy policy from time to time. We will notify you of any 
          changes by posting the new privacy policy on this page.
        </p>

        <h2>7. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us through our 
          <a href="/contact"> Contact page</a>.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;